$(document).ready(function () {


    const windowWidth = window.screen.width;
    const itemWidth = windowWidth / 100 * 60;
    // $(".dtale-slider").css("min-width", itemWidth);
    function slider() {


        const sliderParent = $(".events").find(".event-slider").width();

        const sliderItem = $(".event-slider").find(".dtale-slider");

        const sliderNextTran = sliderParent - 364;

        $(".event-slider").css({ "transform": "translateX( -" + sliderNextTran + "px)" });
    }



    $(".next-btn").click(function (e) {
        e.preventDefault();
        // slider();
    });

    $('.curated-products .slider').slick({
        // fade: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '40px',
                    dots: false
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    $('.testimonials .testimonial-slider').slick({
        dots: true,
        // infinite: true,
        // speed: 500,
        fade: true,
        // cssEase: 'linear'
        arrows: false,
        slidesToShow: 1,
    });

    $('.testimonials .testimonial-mobile-slider').slick({
        dots: true,
        // infinite: true,
        // speed: 500,
        fade: true,
        // cssEase: 'linear'
        arrows: false,
        slidesToShow: 1,
        autoplay: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '40px',
                    dots: false,
                    fade: false
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    $('.instagram-post .content').slick({
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 9999,
                settings: "unslick"
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                }
            }
        ]
    });

    $('.events .event-slider').slick({
        dots: false,
        infinite: false,
        arrows: true,
        slidesToShow: 1,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '20%',
        cssEase: 'ease-in-out',
        speed: 1450,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    centerPadding: '18%',
                }
            },
            {
                breakpoint: 992,
                settings: {
                    centerPadding: '100px',
                }
            },
            {
                breakpoint: 544,
                settings: {
                    centerPadding: '40px',
                    speed: 300,
                    cssEase: 'ease',
                }
            }
        ]
    });




    var slider = $('.award-slider');



    if (slider.length == 1) {

        // $(slider).not('.slick-initialized').slick({
        $(slider).slick({
            dots: false,
            infinite: true,
            arrows: true,
            slidesToShow: 1,
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '20%',
            cssEase: 'ease-in-out',
            speed: 1000,
            responsive: [
                {
                    breakpoint: 1500,
                    settings: {
                        centerPadding: '18%',
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        centerPadding: '100px',
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        centerPadding: '40px',
                        speed: 300,
                        infinite: true,
                    }
                }
            ]
        });


        // var currentSlide;
        // var slidesCount;

        // var curentItem = $(".current_item");
        // var totalItem = $(".total_item");

        // var totalSliders = $(".award-slider .slick-slide").length;

        // var updateSliderCounter = function (slick, currentIndex) {
        //     currentSlide = slick.slickCurrentSlide() + 1;
        //     slidesCount = slick.slideCount;
        //     $(curentItem).text("0" + currentSlide);
        //     $(totalItem).text("0" + totalSliders);
        // };

        // slider.on('init', function (event, slick) {
        //     updateSliderCounter(slick);
        // });

        // slider.on('afterChange', function (event, slick, currentSlide) {
        //     updateSliderCounter(slick, currentSlide);
        // });

        // $(totalItem).text("0" + totalSliders);

    }



    $('.the-workshop .work-shop-slider').slick({
        dots: false,
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '20%',
        cssEase: 'ease-in-out',
        speed: 1000,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    centerPadding: '18%',
                }
            },
            {
                breakpoint: 992,
                settings: {
                    centerPadding: '100px',
                }
            },
            {
                breakpoint: 544,
                settings: {
                    centerPadding: '40px',
                    speed: 300,
                    cssEase: 'ease',
                }
            }
        ]
    });


    $('.store .store-slider').slick({
        dots: false,
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '20%',
        cssEase: 'ease-in-out',
        speed: 1000,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    centerPadding: '18%',
                }
            },
            {
                breakpoint: 992,
                settings: {
                    centerPadding: '100px',
                }
            },
            {
                breakpoint: 544,
                settings: {
                    centerPadding: '40px',
                    speed: 300,
                    cssEase: 'ease',
                }
            }
        ]
    });

    $('.the-brand .brand-slider').slick({
        dots: false,
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '20%',
        cssEase: 'ease-in-out',
        speed: 1000,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    centerPadding: '18%',
                }
            },
            {
                breakpoint: 992,
                settings: {
                    centerPadding: '100px',
                }
            },
            {
                breakpoint: 544,
                settings: {
                    centerPadding: '40px',
                    speed: 300,
                    cssEase: 'ease',
                }
            }
        ]
    });

    $('.event-detail-slider').slick({
        dots: false,
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '20%',
        cssEase: 'ease-in-out',
        speed: 1000,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    centerPadding: '18%',
                }
            },
            {
                breakpoint: 992,
                settings: {
                    centerPadding: '100px',
                }
            },
            {
                breakpoint: 544,
                settings: {
                    centerPadding: '40px',
                    speed: 300,
                    cssEase: 'ease',
                }
            }
        ]
    });

    $('.product-banner-slider').slick({
        dots: false,
        autoplay: true,
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        slidesToShow: 1,
        cssEase: 'ease-in-out',
        speed: 1000,
    });




});